import { MqMessage } from './mqMessageClass'

// 用來存所有已連線的 ports
const ports = []
// 連線的社區名稱，可為 null
let comId = null
// 避免兩個 setTimeout 同時進行
let restartMqMessageCheckTimeout = null
// 維護公告
const mqMessageData = []
// 輪詢進行中
let isChecking = false

// 有 port 連線時
self.onconnect = (event) => {
  const port = event.ports[0]
  ports.push(port)
  port.start()

  // 告訴 client 已經連上了，並同步當前資料
  port.postMessage({
    type: 'updateData',
    data: mqMessageData
  })

  // 接收 client 訊息
  port.onmessage = portOnmessage

  // 當 port 關閉時移除
  port.onclose = () => { portOnclose(port) }
}

/**
 * port on close
 * @param port
 */
const portOnclose = (port) => {
  const index = ports.indexOf(port)
  if (index !== -1) ports.splice(index, 1)
}

/**
 * port on message
 * @param e 事件
 */
const portOnmessage = (e) => {
  const data = e.data
  if (!data || !data.type) return

  switch (data.type) {
    case 'setComId':
      // 設定 comId
      if (comId !== data.data.comId) {
        comId = data.data.comId
        restartMqMessageCheck()
      }
      break
    case 'setNetworkInfo':
      setNetworkInfo(data.data.apiUrl, data.data.apiKey, data.data.wsUrl)
      break
    case 'reload':
      restartMqMessageCheck()
      break
  }
}

/**
 * 設定 MqMessage 連線相關資訊
 * @param apiUrl 輪詢 API Url
 * @param apiKey 輪詢 API Key
 * @param wsUrl 維運公告 ws URL
 */
const setNetworkInfo = (apiUrl, apiKey, wsUrl) => {
  const isSync = mqMessage.syncNetworkInfo(apiUrl, apiKey, wsUrl)
  if (isSync) mqMessage.startMqMessageCheck(comId)
}

/**
 * 更新維運公告到 port
 */
const updateMqMessageData = () => {
  ports.forEach(port => {
    port.postMessage({
      type: 'updateData',
      data: mqMessageData
    })
  })
}

/**
 * 重置連線
 * 終止輪詢以及 websocket，並於 5 秒後重新開始輪詢
 */
const restartMqMessageCheck = () => {
  if (restartMqMessageCheckTimeout) {
    clearTimeout(restartMqMessageCheckTimeout)
    restartMqMessageCheckTimeout = null
  }
  mqMessage.terminationMqMessageCheck()
  // 延遲 5 秒後才重新開始輪詢，避免有訊息連發導致遺漏
  restartMqMessageCheckTimeout = setTimeout(() => {
    mqMessage.startMqMessageCheck(comId || null)
    isChecking = true
  }, isChecking ? 5 * 1000 : 0)
}

const mqMessage = new MqMessage()

mqMessage.addEventListener('mqMessage', (event) => {
  const beforeMqMessageDataLength = mqMessageData.length
  mqMessageData.length = 0
  if (Array.isArray(event.detail)) mqMessageData.push(...event.detail)
  if (mqMessageData.length > 0) {
    updateMqMessageData()
  } else if (beforeMqMessageDataLength !== 0) {
    updateMqMessageData()
    restartMqMessageCheck()
  }
})
